import { Button, Space, Tooltip, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import { DriverVerificationInfoType } from '../../../../graphql/types/driverVerification/DriverVerificationTypes';

export const columns = (
    t: (key: string) => string,
    activeTab: string,
    onReview: (driverAccountId: number) => void,
    onViewLog: (driverAccountId: number) => void,
    vehicleTypeOptions: Array<{ label: string; value: number }>
): ColumnsType<DriverVerificationInfoType> => {
    const baseColumns: ColumnsType<DriverVerificationInfoType> = [
        {
            title: t('riskControl.driverVerification.columns.driverId'),
            dataIndex: 'driverId',
            key: 'driverId',
        },
        {
            title: t('riskControl.driverVerification.columns.name'),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t('riskControl.driverVerification.columns.phone'),
            dataIndex: 'phone',
            key: 'phone',
            render: (phone: string, record: DriverVerificationInfoType) => {
                if (record.countryCode && record.countryCode !== 0) {
                    return `+${record.countryCode} ${phone}`;
                }
                return phone;
            },
        },
        {
            title: t('riskControl.driverVerification.columns.dspName'),
            dataIndex: 'dspName',
            key: 'dspName',
        },
        {
            title: t('riskControl.driverVerification.columns.vehicleType'),
            dataIndex: 'vehicleTypeId',
            key: 'vehicleTypeId',
            render: (vehicleTypeId: number) => {
                const vehicleType = vehicleTypeOptions.find(v => v.value === vehicleTypeId);
                return vehicleType?.label || '-';
            },
        },
        {
            title: t('riskControl.driverVerification.columns.vehiclePlate'),
            dataIndex: 'vehiclePlate',
            key: 'vehiclePlate',
            render: (text) => text || '-',
        },
    ];

    // 操作列：所有状态都显示"审批"和"日志"按钮
    const actionColumn = {
        title: t('riskControl.driverVerification.columns.action'),
        key: 'action',
        render: (_: any, record: DriverVerificationInfoType) => {
            return (
                <Space>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => onReview(record.driverAccountId)}
                    >
                        {t('riskControl.driverVerification.operations.approve')}
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => onViewLog(record.driverAccountId)}
                    >
                        {t('riskControl.driverVerification.operations.log')}
                    </Button>
                </Space>
            );
        },
    };

    return [...baseColumns, actionColumn];
};

